import axios from 'axios';

export class EmailTemplateIndex {
  public static async getFileList(): Promise<any> {
    return axios.get('/api/templates/list');
  }
}
